// Stable per-browser ids: a guest id (links your local save on first sign-in), a device id
// (cloud-save conflicts, bot detection) and an anonymous ad id (frequency caps). No personal data.
function stored(key: string, make: () => string): string {
  try {
    const v = localStorage.getItem(key);
    if (v) return v;
    const n = make();
    localStorage.setItem(key, n);
    return n;
  } catch {
    return make();
  }
}
const rid = () => (crypto.randomUUID?.() ?? `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "").slice(0, 24);

export const guestId = stored("degen-world:guest", () => `g_${rid()}`);
export const deviceId = stored("degen-world:device", () => `d_${rid()}`);
export const anonId = stored("degen-world:anon", () => `a_${rid()}`);
